class DrvGridBanner extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slides]');
    this.slides = this.track ? Array.from(this.track.children) : [];
    if (this.slides.length < 2) return;

    this.bars = Array.from(this.querySelectorAll('.drv-gbanner__bar'));
    this.index = 0;
    this.bars.forEach((bar, i) => bar.addEventListener('click', () => this.go(i)));

    if (window.DrvDrag) {
      window.DrvDrag.swipe(this, () => this.go(this.index - 1), () => this.go(this.index + 1));
    }
  }

  go(i) {
    const count = this.slides.length;
    this.index = (i + count) % count;
    this.track.style.transform = `translateX(${-this.index * 100}%)`;
    this.bars.forEach((bar, j) => bar.classList.toggle('is-active', j === this.index));
  }
}

if (!customElements.get('drv-grid-banner')) {
  customElements.define('drv-grid-banner', DrvGridBanner);
}
